import React from 'react'
import classnames from 'classnames'
import { IsViewport } from '@zambezi/layout-grid'
import { followStoreLink$ } from '../navigation'

import Avatar from './Avatar'

import style from './FundsCheckTppCard.module.css'

export default function FundsCheckTppCard({ tpp, className, index }) {
  const consentCount = tpp.get('consents').size
  return (
    <button
      className={classnames(
        className,
        style.activeCard,
        `js-funds-check-tpp-card-${index}`
      )}
      onClick={() =>
        followStoreLink$.next(
          `/funds-checks/tpps/${tpp.get('clientId')}/funds-checks`
        )
      }
      aria-label={`${tpp.get(
        'clientDisplayName'
      )} has ${consentCount} agreement${consentCount === 1 ? '' : 's'}`}
    >
      <div className={style.content}>
        <span className={style.leftContent}>
          <IsViewport isTablet isDesktop isWidescreen>
            <Avatar
              content={tpp.get('agentName') || tpp.get('clientName')}
              className={`${style.avatar}`}
            />
          </IsViewport>
          <span className={classnames(style.clientName, 'js-tpp-name')}>
            {tpp.get('clientDisplayName')}
          </span>
        </span>
        <span className={`${style.count} ob-brand-colour js-consent-count`}>
          {`${consentCount} agreement${consentCount === 1 ? '' : 's'}`}
        </span>
      </div>
    </button>
  )
}

export function EmptyFundsCheckTppCard() {
  return (
    <div className={classnames('js-funds-check-tpp-card-empty', style.card)}>
      <div className={style.content}>
        <span className={style.leftContent}>
          <IsViewport isTablet isDesktop isWidescreen>
            <Avatar className={style.hiddenAvatar} />
          </IsViewport>
          <span className={`${style.emptyMessage} js-message`}>
            You have no agreements to check your funds
          </span>
        </span>
      </div>
    </div>
  )
}
